// Juurisyyt v2 (#1374): juurisyyt.v2 — the `juurisyytV2` namespace.
// v1's screen keeps its strings under `juurisyyV2`.

export const juurisyytV2Fi = {
  admin: {
    summary: '{{cards}} juurisyytä · {{voted}} äänestetty · {{kept}} hyväksytty · {{toDelete}} hylätty · {{culled}} poistettu kartalta · {{open}} käsittelemättä',
    open: 'Osallistujat voivat vielä arvioida. Lukitse arviot vuonohjauksen painikkeella, kun keskustelu on käyty.',
    locked: 'Osallistujien arviot lukittu {{at}}. Voit yhä hyväksyä ja hylätä itse.',
    unlock: 'Avaa lukitus',
    unlockReason: 'Miksi lukitus avataan? Syy tallennetaan.',
    fold: 'Tekoälyn ja parien juurisyyt ({{count}})',
    vote: 'Osuu {{pct}} % ({{votes}} ääntä)',
    noVotes: 'Ei ääniä',
    grounding: 'Tietopohjaisuus {{score}}',
    noGrounding: 'Ei lähteitä',
    accept: 'Hyväksy',
    reject: 'Hylkää',
    unsure: 'En osaa sanoa',
    outcomes: { keep: 'Hyväksytty', revise: 'Muokattu', reject: 'Hylätty', unsure: 'En osaa sanoa' },
    culled: 'Poistettu kartalta',
    tally: 'Osuu {{approve}} · Ei osu {{reject}}',
    split: 'Esteen kirjoittajat: osuu {{selfApprove}}, ei osu {{selfReject}} · Muut parit: osuu {{outApprove}}, ei osu {{outReject}}',
    earlier: 'Versio {{version}}: osuu {{pct}} %',
    decidedBy: 'Fasilitaattorin päätös ({{by}})',
    acceptAll: 'Hyväksy kaikki arvioimattomat',
    rejectAll: 'Hylkää kaikki arvioimattomat',
    unsureAll: 'Kaikki arvioimattomat: En osaa sanoa',
    unsureAllConfirm: 'Merkitäänkö {{count}} tekoälyn juurisyytä, joista ei ole vielä päätöstä, En osaa sanoa? Ne jäävät kartalle. Parien omiin ja jo päätettyihin ei kosketa.',
    undecided: '{{count}} tekoälyn juurisyytä ilman päätöstä. Parien omiin ei kosketa.',
    acceptAllConfirm: 'Hyväksytäänkö {{count}} tekoälyn juurisyytä, joista ei ole vielä päätöstä? Parien omiin ja jo päätettyihin ei kosketa.',
    rejectAllConfirm: 'Hylätäänkö {{count}} tekoälyn juurisyytä, joista ei ole vielä päätöstä? Lukituksen jälkeen ne poistuvat kartalta heti. Parien omiin ja jo päätettyihin ei kosketa.',
    onWall: 'Näytä seinällä',
    offWall: 'Pois seinältä',
  },
  listTitle: 'Valitse juurisyypakka, ja arvioi ne.',
  mine: 'Omat',
  all: 'Kaikki',
  orbs: 'Kooste',
  others: 'Muiden esteet',
  othersLocked: 'Avautuu, kun omat esteet on arvioitu',
  othersNone: 'Muilla pareilla ei ole vielä esteitä arvioitavaksi.',
  noOwn: 'Teillä ei ole omia esteitä. Arvioikaa muiden esteitä.',
  deriving: 'Kuutio johtaa vielä juurisyitä…',
  question: 'Onko tämä tärkeä juurisyy ongelmalle?',
  holds: 'On',
  notHolds: 'Ei',
  unsure: 'En osaa sanoa',
  cardCount: '{{n}} / {{total}}',
  sourcePair: 'Parin lisäämä',
  chooseCore: 'Onko yksi tai useampi näistä erittäin tärkeä juurisyy?',
  back: 'Takaisin',
  done: 'Valmis',
  sourcesHint: 'Lähteet ja mittarit',
  grounding: 'Tietopohjaisuus {{score}}/100',
  noGrounding: 'Tietopohjaisuus: ei lähteitä',
  noneHeld: 'Yhtäkään juurisyytä ei merkitty tärkeäksi. Kirjoittakaa oma.',
  addOwn: 'Lisää oma juurisyy',
  ownPlaceholder: 'Kirjoita juurisyy…',
  save: 'Tallenna',
  cancel: 'Peruuta',
  celebrateTitle: 'Hienoa!',
  celebrateText: 'Omat esteenne on arvioitu. Nyt voitte arvioida muiden esteitä.',
  celebrateGo: 'Jatka muiden esteisiin',
  repeats: 'Toistuu {{n}} esteessä',
  metrics: 'Mittarit',
  metricProposed: 'Ehdotettu mittari — ei mittausdataa',
  knowledge: 'Tietopohja',
  web: 'Verkko',
  falsifier: 'Mikä kumoaisi tämän',
  noEvidence: 'Työpajan omasta aineistosta ei löytynyt otteita.',
  openSource: 'Avaa lähde',
  close: 'Sulje',
  locked: 'Arviot on lukittu.',
  koosteEmpty: 'Koosteessa ei ole vielä esteitä.',
  kindProblem: 'Ongelma',
  kindBarrier: 'Muutoksen este',
  kindRootCause: 'Juurisyy',
  ofProblem: 'Ongelmasta',
  inBarriers: 'Esteissä',
  countBarriers: '{{n}} estettä',
  countRootCauses: '{{n}} hyväksyttyä juurisyytä',
  koosteLoading: 'Ladataan koostetta…',
  error: 'Jokin meni pieleen',
  finished: 'Valmiit juurisyypakat',
  allCount: 'Kaikki, {{count}} juurisyytä',
  legend: 'Selite',
  lookCore: 'Erittäin tärkeä',
  lookSplit: 'Jaettu',
  lookHolds: 'Hyväksytty',
  lookNot: 'Hylätty',
  lookOpen: 'Arvioimaton',
  votes: 'On {{osuu}} · Ei {{eiOsu}} · En osaa sanoa {{eos}} · Erittäin tärkeä {{core}}',
  votesByRole: 'Kirjoittajat: {{own}} — Muut parit: {{outside}}',
};

export const juurisyytV2En = {
  admin: {
    summary: '{{cards}} root causes · {{voted}} voted on · {{kept}} accepted · {{toDelete}} rejected · {{culled}} removed from the map · {{open}} not yet decided',
    open: 'The participants can still judge. Lock the judgements with the flow control button once the discussion is done.',
    locked: 'The participants\u2019 judgements were locked {{at}}. You can still accept and reject yourself.',
    unlock: 'Unlock',
    unlockReason: 'Why unlock? The reason is kept.',
    fold: 'The root causes from the AI and the pairs ({{count}})',
    vote: 'Holds {{pct}} % ({{votes}} votes)',
    noVotes: 'No votes',
    grounding: 'Research basis {{score}}',
    noGrounding: 'No sources',
    accept: 'Accept',
    reject: 'Reject',
    unsure: 'Not sure',
    outcomes: { keep: 'Accepted', revise: 'Revised', reject: 'Rejected', unsure: 'Not sure' },
    culled: 'Removed from the map',
    tally: 'Holds {{approve}} · Does not hold {{reject}}',
    split: 'The obstacle\u2019s writers: holds {{selfApprove}}, does not hold {{selfReject}} · Other pairs: holds {{outApprove}}, does not hold {{outReject}}',
    earlier: 'Version {{version}}: holds {{pct}} %',
    decidedBy: 'The facilitator\u2019s decision ({{by}})',
    acceptAll: 'Accept all undecided',
    rejectAll: 'Reject all undecided',
    unsureAll: 'All undecided: Not sure',
    unsureAllConfirm: 'Mark {{count}} of the AI\u2019s root causes that have no decision yet as Not sure? They stay on the map. The pairs\u2019 own and those already decided are not touched.',
    undecided: '{{count}} of the AI\u2019s root causes without a decision. The pairs\u2019 own are not touched.',
    acceptAllConfirm: 'Accept {{count}} of the AI\u2019s root causes that have no decision yet? The pairs\u2019 own and those already decided are not touched.',
    rejectAllConfirm: 'Reject {{count}} of the AI\u2019s root causes that have no decision yet? After the lock they leave the map at once. The pairs\u2019 own and those already decided are not touched.',
    onWall: 'Show on the wall',
    offWall: 'Off the wall',
  },
  listTitle: 'Choose a deck of root causes and assess them.',
  mine: 'Mine',
  all: 'All',
  orbs: 'Overview',
  others: 'Others’ obstacles',
  othersLocked: 'Opens once your own obstacles are judged',
  othersNone: 'Other pairs have no obstacles to judge yet.',
  noOwn: 'You have no obstacles of your own. Judge others’ obstacles.',
  deriving: 'Kuutio is still deriving root causes…',
  question: 'Is this an important root cause of the problem?',
  holds: 'Yes',
  notHolds: 'No',
  unsure: 'Not sure',
  cardCount: '{{n}} / {{total}}',
  sourcePair: 'Added by a pair',
  chooseCore: 'Is one or more of these a very important root cause?',
  back: 'Back',
  done: 'Done',
  sourcesHint: 'Sources and metrics',
  grounding: 'Research basis {{score}}/100',
  noGrounding: 'Research basis: no sources',
  noneHeld: 'No root cause was marked important. Write your own.',
  addOwn: 'Add your own root cause',
  ownPlaceholder: 'Write the root cause…',
  save: 'Save',
  cancel: 'Cancel',
  celebrateTitle: 'Well done!',
  celebrateText: 'Your own obstacles are judged. Now you can judge others’ obstacles.',
  celebrateGo: 'Go on to others’ obstacles',
  repeats: 'Recurs in {{n}} obstacles',
  metrics: 'Metrics',
  metricProposed: 'Proposed metric — no measured data',
  knowledge: 'Knowledge base',
  web: 'Web',
  falsifier: 'What would refute this',
  noEvidence: 'No excerpts were found in the workshop’s own datasets.',
  openSource: 'Open the source',
  close: 'Close',
  locked: 'Judgements are locked.',
  koosteEmpty: 'There are no obstacles in the overview yet.',
  kindProblem: 'Problem',
  kindBarrier: 'Obstacle to change',
  kindRootCause: 'Root cause',
  ofProblem: 'Of the problem',
  inBarriers: 'In the obstacles',
  countBarriers: '{{n}} obstacles',
  countRootCauses: '{{n}} accepted root causes',
  koosteLoading: 'Loading the overview…',
  error: 'Something went wrong',
  finished: 'Finished decks',
  allCount: 'All, {{count}} root causes',
  legend: 'Key',
  lookCore: 'Very important',
  lookSplit: 'Split',
  lookHolds: 'Accepted',
  lookNot: 'Rejected',
  lookOpen: 'Not assessed',
  votes: 'Yes {{osuu}} · No {{eiOsu}} · Not sure {{eos}} · Very important {{core}}',
  votesByRole: 'Its writers: {{own}} — Other pairs: {{outside}}',
};

export const juurisyytV2Sv = {
  admin: {
    summary: '{{cards}} grundorsaker · {{voted}} röstade · {{kept}} godkända · {{toDelete}} avvisade · {{culled}} borttagna från kartan · {{open}} obehandlade',
    open: 'Deltagarna kan fortfarande bedöma. Lås bedömningarna med flödesstyrningens knapp när diskussionen är förd.',
    locked: 'Deltagarnas bedömningar låstes {{at}}. Du kan fortfarande godkänna och avvisa själv.',
    unlock: 'Lås upp',
    unlockReason: 'Varför låses det upp? Orsaken sparas.',
    fold: 'Grundorsakerna från AI:n och paren ({{count}})',
    vote: 'Stämmer {{pct}} % ({{votes}} röster)',
    noVotes: 'Inga röster',
    grounding: 'Kunskapsunderlag {{score}}',
    noGrounding: 'Inga källor',
    accept: 'Godkänn',
    reject: 'Avvisa',
    unsure: 'Vet inte',
    outcomes: { keep: 'Godkänd', revise: 'Ändrad', reject: 'Avvisad', unsure: 'Vet inte' },
    culled: 'Borttagen från kartan',
    tally: 'Stämmer {{approve}} · Stämmer inte {{reject}}',
    split: 'Hindrets skribenter: stämmer {{selfApprove}}, stämmer inte {{selfReject}} · Övriga par: stämmer {{outApprove}}, stämmer inte {{outReject}}',
    earlier: 'Version {{version}}: stämmer {{pct}} %',
    decidedBy: 'Facilitatorns beslut ({{by}})',
    acceptAll: 'Godkänn alla obehandlade',
    rejectAll: 'Avvisa alla obehandlade',
    unsureAll: 'Alla obehandlade: Vet inte',
    unsureAllConfirm: 'Markera {{count}} av AI:ns grundorsaker som ännu saknar beslut som Vet inte? De stannar kvar på kartan. Parens egna och de som redan har beslut berörs inte.',
    undecided: '{{count}} av AI:ns grundorsaker utan beslut. Parens egna berörs inte.',
    acceptAllConfirm: 'Godkänna {{count}} av AI:ns grundorsaker som ännu saknar beslut? Parens egna och de som redan har beslut berörs inte.',
    rejectAllConfirm: 'Avvisa {{count}} av AI:ns grundorsaker som ännu saknar beslut? Efter låsningen försvinner de från kartan direkt. Parens egna och de som redan har beslut berörs inte.',
    onWall: 'Visa på väggen',
    offWall: 'Bort från väggen',
  },
  listTitle: 'Välj en kortlek med grundorsaker och bedöm dem.',
  mine: 'Mina',
  all: 'Alla',
  orbs: 'Översikt',
  others: 'Andras hinder',
  othersLocked: 'Öppnas när era egna hinder är bedömda',
  othersNone: 'Andra par har inga hinder att bedöma ännu.',
  noOwn: 'Ni har inga egna hinder. Bedöm andras hinder.',
  deriving: 'Kuutio härleder fortfarande grundorsaker…',
  question: 'Är det här en viktig grundorsak till problemet?',
  holds: 'Ja',
  notHolds: 'Nej',
  unsure: 'Vet inte',
  cardCount: '{{n}} / {{total}}',
  sourcePair: 'Tillagd av ett par',
  chooseCore: 'Är en eller flera av dessa en mycket viktig grundorsak?',
  back: 'Tillbaka',
  done: 'Klar',
  sourcesHint: 'Källor och mätare',
  grounding: 'Kunskapsunderlag {{score}}/100',
  noGrounding: 'Kunskapsunderlag: inga källor',
  noneHeld: 'Ingen grundorsak markerades som viktig. Skriv en egen.',
  addOwn: 'Lägg till en egen grundorsak',
  ownPlaceholder: 'Skriv grundorsaken…',
  save: 'Spara',
  cancel: 'Avbryt',
  celebrateTitle: 'Bra jobbat!',
  celebrateText: 'Era egna hinder är bedömda. Nu kan ni bedöma andras hinder.',
  celebrateGo: 'Fortsätt till andras hinder',
  repeats: 'Återkommer i {{n}} hinder',
  metrics: 'Mätare',
  metricProposed: 'Föreslagen mätare — inga mätdata',
  knowledge: 'Kunskapsbas',
  web: 'Webben',
  falsifier: 'Vad skulle motbevisa detta',
  noEvidence: 'Inga utdrag hittades i workshoppens eget material.',
  openSource: 'Öppna källan',
  close: 'Stäng',
  locked: 'Bedömningarna är låsta.',
  koosteEmpty: 'Det finns inga hinder i översikten ännu.',
  kindProblem: 'Problem',
  kindBarrier: 'Hinder för förändring',
  kindRootCause: 'Grundorsak',
  ofProblem: 'Ur problemet',
  inBarriers: 'I hindren',
  countBarriers: '{{n}} hinder',
  countRootCauses: '{{n}} godkända grundorsaker',
  koosteLoading: 'Översikten laddas…',
  error: 'Något gick fel',
  finished: 'Färdiga kortlekar',
  allCount: 'Alla, {{count}} grundorsaker',
  legend: 'Förklaring',
  lookCore: 'Mycket viktig',
  lookSplit: 'Delad',
  lookHolds: 'Godkänd',
  lookNot: 'Avvisad',
  lookOpen: 'Inte bedömd',
  votes: 'Ja {{osuu}} · Nej {{eiOsu}} · Vet inte {{eos}} · Mycket viktig {{core}}',
  votesByRole: 'Skribenterna: {{own}} — Andra par: {{outside}}',
};
